module.exports = __webpack_public_path__ + "img/partone_pic.3caf8624.png";